/**
 * Grafana Alloy API Service
 *
 * Provides CRUD operations for Alloy configurations and child jobs.
 * Each sub-domain (Config, SNMP, Blackbox, Fortigate, Darkstat) lives in its
 * own file; this index re-exports the full public surface for back-compat
 * with existing `import {X} from '@/services/alloyService'` callers.
 */

export {
  getAllAlloyConfigs,
  getAlloyConfigsWithPagination,
  getAlloyConfigById,
  createAlloyConfig,
  updateAlloyConfig,
  deleteAlloyConfig,
  approveAlloyConfig,
  denyAlloyConfig,
  bulkDeleteAlloyConfigs,
} from "./config";

export {
  getAlloySNMPByConfig,
  getAlloySNMPById,
  createAlloySNMP,
  updateAlloySNMP,
  deleteAlloySNMP,
} from "./snmp";

export {
  getAlloyBlackboxByConfig,
  getAlloyBlackboxById,
  createAlloyBlackbox,
  updateAlloyBlackbox,
  deleteAlloyBlackbox,
} from "./blackbox";

export {
  getAlloyFortigateByConfig,
  getAlloyFortigateById,
  createAlloyFortigate,
  updateAlloyFortigate,
  deleteAlloyFortigate,
} from "./fortigate";

export {
  getAlloyDarkstatByConfig,
  getAlloyDarkstatById,
  createAlloyDarkstat,
  updateAlloyDarkstat,
  deleteAlloyDarkstat,
} from "./darkstat";

import {
  getAllAlloyConfigs,
  getAlloyConfigsWithPagination,
  getAlloyConfigById,
  createAlloyConfig,
  updateAlloyConfig,
  deleteAlloyConfig,
  approveAlloyConfig,
  denyAlloyConfig,
  bulkDeleteAlloyConfigs,
} from "./config";
import {
  getAlloySNMPByConfig,
  getAlloySNMPById,
  createAlloySNMP,
  updateAlloySNMP,
  deleteAlloySNMP,
} from "./snmp";
import {
  getAlloyBlackboxByConfig,
  getAlloyBlackboxById,
  createAlloyBlackbox,
  updateAlloyBlackbox,
  deleteAlloyBlackbox,
} from "./blackbox";
import {
  getAlloyFortigateByConfig,
  getAlloyFortigateById,
  createAlloyFortigate,
  updateAlloyFortigate,
  deleteAlloyFortigate,
} from "./fortigate";
import {
  getAlloyDarkstatByConfig,
  getAlloyDarkstatById,
  createAlloyDarkstat,
  updateAlloyDarkstat,
  deleteAlloyDarkstat,
} from "./darkstat";

export default {
  getAllAlloyConfigs,
  getAlloyConfigsWithPagination,
  getAlloyConfigById,
  createAlloyConfig,
  updateAlloyConfig,
  deleteAlloyConfig,
  approveAlloyConfig,
  denyAlloyConfig,
  bulkDeleteAlloyConfigs,
  getAlloySNMPByConfig,
  getAlloySNMPById,
  createAlloySNMP,
  updateAlloySNMP,
  deleteAlloySNMP,
  getAlloyBlackboxByConfig,
  getAlloyBlackboxById,
  createAlloyBlackbox,
  updateAlloyBlackbox,
  deleteAlloyBlackbox,
  getAlloyFortigateByConfig,
  getAlloyFortigateById,
  createAlloyFortigate,
  updateAlloyFortigate,
  deleteAlloyFortigate,
  getAlloyDarkstatByConfig,
  getAlloyDarkstatById,
  createAlloyDarkstat,
  updateAlloyDarkstat,
  deleteAlloyDarkstat,
};
